/* global Swiper */
// eslint-disable-next-line no-new
new Swiper("[data-slider]", {
  loop: true,
  grabCursor: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  autoplay: {
    delay: 3500,
    disableOnInteraction: false,
  },
})

// eslint-disable-next-line no-new
new Swiper("[data-documents-slider]", {
  loop: false,
  direction: "horizontal",
  slidesPerView: 3,
  grabCursor: false,
  simulateTouch: false,
  noSwiping: true,
  breakpoints: {
    640: {
      slidesPerView: "auto",
      loop: false,
      spaceBetween: 1,
      simulateTouch: true,
      noSwiping: false,
    },
  },
})



// WEBPACK FOOTER //
// ./src/blocks/slider/slider.js